module.exports = __webpack_public_path__ + "media/images/produtos-e-marcas-2-81998f0349b7b7375a245c5b35f47d4a.jpg";